import React from 'react';
import PropTypes from 'prop-types';
import { GMAP_CONTROLLED_ICON } from '../../../../../../common/constants';

import { InfoBox } from '@react-google-maps/api';
import {
  AMBER_3,
  AMBER_6,
  GREEN_3,
  GREEN_6,
  GREY,
  RED_3,
  RED_6
} from 'components/FlyingV2/styles/constants';

export const AircraftRegistrationLabel = ({
  backgroundColor,
  borderColor,
  position,
  label,
  zIndex
}) => {
  return (
    <InfoBox
      position={position}
      zIndex={zIndex}
      options={{
        pixelOffset: new window.google.maps.Size(
          GMAP_CONTROLLED_ICON.width / 2, // shift left by half of icon width
          -15 // shift up by half the infobox height
        ),

        boxStyle: {
          backgroundColor,
          opacity: 1,
          width: 'auto',
          padding: '5px',
          borderRadius: '.5em',
          minWidth: '45px',
          border: `1px solid ${borderColor}`,
          zIndex: -1
        },
        disableAutoPan: true,
        closeBoxURL: ''
      }}
    >
      <div className="info-window-label" style={{ fontSize: '12px' }}>
        {label}
      </div>
    </InfoBox>
  );
};

AircraftRegistrationLabel.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  position: PropTypes.object,
  label: PropTypes.string,
  zIndex: PropTypes.number
};

export default function InactiveAircraftRegistrationLabel(props) {
  return (
    <AircraftRegistrationLabel
      backgroundColor="silver"
      borderColor="rgb(102, 102, 102)"
      {...props}
    />
  );
}

export const StandardAircraftRegistrationLabel = props => {
  let labelColor = 'rgb(216, 231, 131)';
  let borderColor = 'rgb(197, 219, 61)';
  if (props?.isV2) {
    if (props?.mainColour === GREEN_6) {
      labelColor = GREEN_3;
      borderColor = GREEN_6;
    } else if (props?.mainColour === AMBER_6) {
      labelColor = AMBER_3;
      borderColor = AMBER_6;
    } else if (props?.mainColour === GREY) {
      labelColor = GREY;
      borderColor = 'rgb(102, 102, 102)';
    } else {
      console.error(
        'StandardAircraftRegistrationLabel has unexpected colour',
        props,
        props.mainColour
      );
    }
  }
  return (
    <AircraftRegistrationLabel backgroundColor={labelColor} borderColor={borderColor} {...props} />
  );
};

export const SOSAircraftRegistrationLabel = props => {
  if (props?.isV2) {
    return <AircraftRegistrationLabel backgroundColor={RED_3} borderColor={RED_6} {...props} />;
  } else {
    return <AircraftRegistrationLabel backgroundColor="red" borderColor="pink" {...props} />;
  }
};
